export default {"src":"/nachrichten/_next/static/media/not-found-light.8a24ea26.svg","height":130,"width":187,"blurWidth":0,"blurHeight":0};